<template>
  <div class="container mt-4">
    <h2 class="titulo-proceso">Proceso de Contratación de Deuda Pública</h2>
    <div v-for="documento in documentos" :key="documento.id" class="mb-4">
      <h4 class="text-primary">Año: {{ documento.titulo }}</h4> <!-- Cambié a 'Año' para mayor claridad -->
      
      <div v-for="seccion in documento.secciones" :key="seccion.id_seccion" class="mb-4">
        <h5 class="text-secondary">{{ seccion.titulo_seccion }}</h5>

        <!-- Ciclo sobre los archivos dentro de cada sección -->
        <div class="row mb-3" v-for="archivo in seccion.archivos_seccion" :key="archivo.id_archivo">
          <div class="col-md-1 text-center">
            <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" alt="PDF Icon" width="50">
          </div>
          <div class="col-md-11">
            <div class="card-body">
              <p class="card-title mb-1">
                <strong>Nombre:</strong> <span class="text-danger">{{ archivo.titulo }}</span>
              </p>
              <p class="card-text mb-1"><strong>Tipo:</strong> Documento PDF</p>
              <p class="card-text mb-1"><strong>Tamaño:</strong> {{ calcularTamano(archivo.url_pdf) }}</p>
              <a :href="archivo.url_pdf" class="btn btn-sm btn-outline-primary" target="_blank">Ver Documento</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    documentos: {
      type: Array,
      required: true
    }
  },
  methods: {
    calcularTamano(url) {
      // Puedes agregar lógica para obtener el tamaño si tienes acceso a esa información
      return 'Tamaño desconocido';
    }
  }
}
</script>

<style scoped>
.titulo-proceso {
  font-weight: bold;
  color: #621132;
}

.text-primary {
  color: #621132 !important;
}

.text-secondary {
  color: #000 !important;
}

.card-body {
  background-color: rgba(98, 17, 50, 0.05);
  padding: 1rem;
  border-radius: 0.25rem;
}

.card-body:hover {
  background-color: rgba(98, 17, 50, 0.1);
  transform: scale(1.02);
  transition: all 0.3s ease;
}

img {
  margin-bottom: 0.5rem;
}

.btn-outline-primary {
  border-color: #621132;
  color: #621132;
}

.btn-outline-primary:hover {
  background-color: #621132;
  color: #fff;
}
</style>
